var path = 'src/app/cohorts/cohort-list.html';
var html = "<div page-wrapper> <h1 class=page-header>Cohorts</h1> <div loading=loading> <ul> <li ng-repeat=\"cohort in cohorts\"><a ui-sref=\"cohort({cohortId: cohort.id})\">{{cohort.name}}</a> ({{cohort.code}})</li> </ul> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/cohorts/cohort-list.html
 ** module id = 69
 ** module chunks = 0
 **/